import React, { ReactElement } from 'react'
import './Layout.scss'
import { Layout } from 'antd';
const { Content } = Layout;
import HeaderMenu from './HeaderMenu'

export enum notifyType {
  CANXACNHANBAOGIA = 'CANXACNHANBAOGIA',
  COTHAYDOIBAOGIA = 'COTHAYDOIBAOGIA',
  COYEUCAUMUA = 'COYEUCAUMUA',
  CMTYEUCAUMUA = 'CMTYEUCAUMUA',
  COYEUCAUTACH = 'COYEUCAUTACH',
  COYEUCAUTHANHTOAN = 'COYEUCAUTHANHTOAN',
}

interface Props {
  children: ReactElement
}
const BasicLayout: React.FC<Props> = ({ children }) => {
  
  return (
    <Layout style={{ borderTop: '2px solid grey' }}>
      <HeaderMenu />
      <Layout className="site-layout">
        <Content
          className="site-layout-background"
          style={{
            minHeight: "95vh"
          }}
        >
          <div className="basic-layout-content" style={{
            minHeight: "95vh"
          }}
          >{children}</div>
        </Content>
      </Layout>
    </Layout >
  )
}

export default BasicLayout
